import { Component, Input } from '@angular/core';

@Component({
  selector: 'glowing-ring',
  templateUrl: './glowing-ring.component.html',
  styleUrls: ['./glowing-ring.component.css']
})
export class GlowingRingComponent {
  @Input() primaryColor: string = '#FFF';  // Default primary color
  @Input() secondaryColor: string = '#FF3D00'; // Default secondary color
  @Input() thickness: number = 3;   // Default thickness
  @Input() width: number = 48;      // Default width

  ngOnInit() {
    this.width = Number(this.width) || 48;   
    this.thickness = Number(this.thickness) || 3; 

  }
}
